/**
 * Map API relationshipType to display label for chat.
 */
export function getConnectionBadgeLabel(relationshipType) {
  if (!relationshipType) return 'Ostalo';
  const t = String(relationshipType).toLowerCase();
  if (t === 'babysitter' || t === 'dadilja') return 'Roditelj↔Dadilja';
  if (t === 'family' || t === 'porodica') return 'Porodica';
  if (t === 'friend' || t === 'prijatelj') return 'Prijatelj';
  return 'Ostalo';
}

export const CONNECTION_BADGE_COLORS = {
  'Prijatelj': 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  'Porodica': 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  'Roditelj↔Dadilja': 'bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300',
  'Ostalo': 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
};
